import { jwtDecode } from "jwt-decode";

import RoleBasedAccessControlOrigin from '../../utils/stringLiterals/RoleBasedAccessControlOrigin';
import LocalStorageDataStorer from "../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../dataAccessLayer/localStorage/LocalStorageKey";
import JsTypeInspector from "../validators/JsTypeInspector";
import ResourcesManager from "../../businessLayer/managers/ResourcesManager";
import HttpResponseStatusCode from "../../utils/httpProtocol/HttpStatusCode";


const userHasPermission = function(resource, action){
    const jwtUserToken = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.jwtUserToken);   
    const isNotJwtUserToken = JsTypeInspector.objectIsNullOrEmpty(jwtUserToken);
    if(isNotJwtUserToken){
        return false;
    }     
    const decodedToken = jwtDecode( jwtUserToken );
    const userClaims = decodedToken?.policy?.claimsAndPermissions?.customer || {};
        
    const userCanClaimAccessToResource = userClaims[resource];
    const isNotAuthorized = JsTypeInspector.objectIsNullOrEmpty(userCanClaimAccessToResource);
    if(isNotAuthorized){
        return false;
    }

    const userHasPermissionToAction = userCanClaimAccessToResource.find((allowedPermission)=>{
        ////console.log("allowedPermission", allowedPermission);
        return (allowedPermission === action)
    })

    const hasNoPermission = JsTypeInspector.objectIsNullOrEmpty(userHasPermissionToAction);
    if(hasNoPermission){
        return false;
    }

    return true;
}

async function getAllresourcesFromAPIAsync(origin){
    return await new Promise((resolve, reject) => { 
        ResourcesManager.getAllResourcesAndActions(processAllResourcesAndActionsCallback);

        function processAllResourcesAndActionsCallback(httpResponse){
            //console.log("app-processAllResourcesAndActionsCallback-httpResponse" , httpResponse);
            if(httpResponse.code === HttpResponseStatusCode._200ok.code && httpResponse.payload){

                const allResources = getResourcesAndActionsByOrigin(origin, httpResponse.payload);    
                //console.log("getAllresourcesFromAPIAsync-allResources:", allResources);
                resolve(allResources);                
            } 
            else { 
                reject(httpResponse.message || "Failed to fetch resources"); 
            } 
        }
    });
}

//#region Private Functions BEGIN


function getResourcesAndActionsByOrigin(origin, payload){

    let resources = null;
    switch(origin){

        case RoleBasedAccessControlOrigin.frontend:
            resources = getFormattedResourcesAndActions(origin, payload.FrontEndResourcesAndActions);

        break;

        case RoleBasedAccessControlOrigin.customer: 
            resources = getFormattedResourcesAndActions(origin, payload.CustomerResourcesAndActions);
        break;

        case RoleBasedAccessControlOrigin.api:
            resources = getFormattedResourcesAndActions(origin, payload.APIResourcesAndActions);
        break;
    }

    return resources;
}


function getFormattedResourcesAndActions(origin, selectedResources){
    //console.log("getFormattedResourcesAndActions-selectedResources", selectedResources);
    let objResource = {};
    selectedResources.forEach((item)=>{
        if(item.origin === origin){
            objResource[item.resource.name] = {
                name : item.resource.name,
                actions:{}
            };
            let newResource = objResource[item.resource.name];
            item.actions.forEach((action)=>{
                newResource.actions[action.name]= action.name;
            });

        }
    });
    
    const selectedResource = Object.freeze({
        resource : objResource
    });

    return selectedResource.resource;
}

//#region Private Functions END

const AccessControlInspector =  Object.freeze({
    getAllresourcesFromAPIAsync : getAllresourcesFromAPIAsync,
    userHasPermission : userHasPermission
});


export default AccessControlInspector;